import { FC } from 'react';
import { Text } from '@doda/io-react/common';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useAppSelector } from 'redux/hooks';
import { OTHER_PAGE_LINK_TITLE } from '@doda/common/src/constants/seo/jobContentCommonConstants';
import { OTHER_PAGE_LINK_ITEMS } from '@doda/common/src/constants/seo/jobTrendConstants';
import { generateOtherPageLinkUrl } from '@doda/common/src/logics/JobContent/generateOtherPageLinkUrl';
import { OtherPageLinkItem } from '@doda/pc/src/components/JobContent/OtherPageLinkItem';
import { useAppDispatch } from '@doda/common/src/redux/hooks';
import styles from './index.module.scss';

/**
 * OtherPageLinkのProps
 * @param targetName ページの一軸名
 */
interface Props {
  targetName: string;
}

export const OtherPageLink: FC<Props> = ({ targetName }) => {
  // queryの取得
  const queryParams = useAppSelector(appQueryParamsSelector);
  const dispatch = useAppDispatch();
  return (
    <div className={styles.otherPageLink}>
      <Text
        as="h2"
        size="20"
        color="black_pc"
        weight="bold"
        className={styles.otherPageLink__title}
      >
        {targetName}
        {OTHER_PAGE_LINK_TITLE}
      </Text>
      <div className={styles.otherPageLink__list}>
        {OTHER_PAGE_LINK_ITEMS.map(
          ({
            title,
            description,
            siteUrl,
            imagePath,
            preBtn,
            handleMeasurement,
          }) => (
            <OtherPageLinkItem
              key={title}
              title={title}
              description={description}
              linkUrl={generateOtherPageLinkUrl({
                queryParams,
                siteUrl,
                preBtn,
              })}
              imagePath={imagePath}
              onClick={() => dispatch(handleMeasurement())}
            />
          )
        )}
      </div>
    </div>
  );
};
